// Catalog mapping steps (CatalogMappingDatabaseViewModel.MoveDataFrom* and
// RemoveCrew / RemoveTool): putting a crew or tool on a catalog division
// adds its code to the division's CrewCodes / EquipmentCodes, and adds the
// division's AWP to the crew's / tool's AWP list.

export const toArray = (v) =>
  Array.isArray(v) ? v : v ? String(v).split(",").map((s) => s.trim()).filter(Boolean) : [];

export function assignCodes(catalogRec, field, codes) {
  const current = toArray(catalogRec[field]);
  return { ...catalogRec, [field]: [...current, ...codes.filter((c) => !current.includes(c))] };
}

export function unassignCode(catalogRec, field, code) {
  return { ...catalogRec, [field]: toArray(catalogRec[field]).filter((c) => c !== code) };
}

// The crew / tool with the division's AWP added, or null when nothing changes.
export function withDivisionAwp(rec, awp) {
  if (!awp || awp === "(None)") return null;
  const list = toArray(rec.Awp);
  if (list.includes(awp)) return null;
  return { ...rec, Awp: [...list, awp] };
}

// CatalogsDatabaseViewModel item ticks: ticking a division ticks or unticks
// everything under it (MakeChildSelection); ticking also ticks its parents
// (MakeParentSelection). `sorted` is the division list in tree order with
// Level set. Returns the keys to change.
export function divisionTickKeys(sorted, key, checked) {
  const list = sorted || [];
  const i = list.findIndex((d) => d.key === key);
  if (i < 0) return [];
  const level = (d) => Number(d.rec.Level) || 1;
  const keys = [key];
  for (let j = i + 1; j < list.length && level(list[j]) > level(list[i]); j += 1) keys.push(list[j].key);
  if (checked) {
    let current = level(list[i]);
    for (let j = i - 1; j >= 0 && current > 1; j -= 1) {
      if (level(list[j]) < current) {
        keys.push(list[j].key);
        current = level(list[j]);
      }
    }
  }
  return keys;
}

// CatalogMappingDatabaseViewModel.GetSelectedLaborItems / GetSelectedToolsItems
// and the saves they feed: the crews mapped on the ticked divisions with all
// their labours, and the tools mapped there with their tool types, each once.
export function resourcesUnderDivisions(divisions, { crews = [], labors = [], tools = [], groups = [] }) {
  const crewCodes = new Set();
  const toolCodes = new Set();
  (divisions || []).forEach((d) => {
    toArray(d.CrewCodes).forEach((c) => crewCodes.add(String(c)));
    toArray(d.EquipmentCodes).forEach((c) => toolCodes.add(String(c)));
  });
  const crewRecs = crews.filter((c) => crewCodes.has(String(c.Code)));
  const crewSet = new Set(crewRecs.map((c) => String(c.Code)));
  const laborRecs = labors.filter((l) => crewSet.has(String(l.Crew)));
  const toolRecs = tools.filter((t) => toolCodes.has(String(t.Code)));
  const groupSet = new Set(toolRecs.map((t) => String(t.Group)));
  const groupRecs = groups.filter((g) => groupSet.has(String(g.Code)));
  return { crews: crewRecs, labors: laborRecs, tools: toolRecs, groups: groupRecs };
}
